<template>
  <div class="topDiv d-flex align-items-center">
    <div>
      <b-form-checkbox
        switch
        :disabled="disabled"
        class="mt-2 visibility-unselected-profile-switch"
        :class="{ 'disablepointer disableswitch': disabled, bindingClass }"
        size="lg"
        :id="id"
        :type="type"
        :placeholder="placeholder"
        v-model="inputData"
        @input="type == $emit('select-value', inputData)"
        tabindex="0"
      ></b-form-checkbox>
    </div>
    <div class="mt-3">
      <label class="teams-label-font mb-1">{{ label }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: "Switch",
  props: {
    bindingClass: String,
    disabled: Boolean,
    type: String,
    label: String,
    mandatory: Boolean,
    placeholder: String,
    id: String,
    vmodel: {
      validator: function () {
        // Accept any type
        return true;
      },
    },
  },
  data() {
    return {
      inputData: false,
    };
  },
  watch: {
    // Follow the value when the form sets it after this field was created
    // (e.g. Upload JD fills the job form), like the other input components.
    vmodel(newVal) {
      this.inputData = !!newVal;
    },
  },
  created() {
    if (this.vmodel) {
      this.inputData = this.vmodel;
    }
  },
};
</script>
